export const environment = {
    production: true,
    RECAPTCHA_SITE_KEY: '6LcKMMEkAAAAAN-UBDLHJb2MBPlGJka8cBqAe2v4',
    VISIBLE_RECAPTCHA_SITE_KEY: '6LfezAIrAAAAAFLwivou5o5_vDAVv1Aq-RDuAxHT',
    AUTHORIZED_PARTNERS_PHONE_NUMBERS: '/IONCOURT/IONIC:AUTHORIZED_PARTNERS_PHONE_NUMBERS'
};

export const SERVER_URL = 'https://api.ioncourt.com/api'; 
export const SOCKET_URL = 'https://api.ioncourt.com';
export const END_POINT =  'https://ioncourt.com';
export const PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApnkmnD4rtZFjJ7lcOjlg\nZvQQLNB8ORB5ZsNx9rgXj5u+yI9xPBYsbxuy5WBnJxsQWycHtJQsKnN7yhYv+1Pk\naOkxM8Jkz5Z4Y28II/ByePffXgani6PFNcPB0OYDLxsMYCwFsx8spZih87EnFlb5\n9aSm4WOPYrA174iYRqLO3cxjcQLZ4NsCISQHvM/WURZOFJzqRiVa1kFkL1Um/SKB\nCypjjzfmfBEziacUfjJNZRg2UdBDj4ztOxJRtJFZEr6o7DvDaLD+F4erNtkdE+RI\nSb0ELHGHkJ0BBvm6+qbrUUYjAvKpw4RFTjR97kD9Q/2XgbSH0LMlXXVukmG47y83\nBQIDAQAB\n-----END PUBLIC KEY-----'
export const WEBSITE_WIDGET_URL = 'https://widget.ioncourt.com'
export const TMX_EXPORT_PDF_URL = 'https://rt7s4blfwwfprwnupad6m3wboi0piuae.lambda-url.us-east-1.on.aws';

export const SOCKET_PATH = '/socket/socket.io';

export const FIREBASE_ANALYTICS = {
 apiKey: '/IONCOURT/IONIC:API_KEY',
 authDomain: '/IONCOURT/IONIC:AUTH_DOMAIN',
 databaseURL: 'https://ioncourt-8bcd4.firebaseio.com',
 projectId: 'ioncourt-8bcd4',
 storageBucket: 'ioncourt-8bcd4.appspot.com',
 messagingSenderId: '211885406782',
 appId: '1:211885406782:web:444d3c786da4501afb6f6f',
 measurementId: 'G-QH0NXK5XY8'
};

export const adId = '';

export const INDEX_USER_PASSWORD = 'Aces12345';
export const SCORE_UPDATE_DELAY = 1000;
export const ITA_URL = 'https://colleges.wearecollegetennis.com';
export const IS_NEW_UI_FLOW = 'true';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
